<script lang="ts">
  import MyDonationList from '../../components/employee/myDonations/myDonationList.svelte';
</script>

<div class="my-donations-page">
  <MyDonationList />
</div>

<style>
  .my-donations-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style>